import { combineReducers } from "redux";

import bookingModalsReducer from "./bookingModalsReducer";
import candidateModalsReducer from "./candidateModalsReducer";
import generalModalsReducer from "./generalModalsReducer";

const modalsGlobalReducer = combineReducers({
  bookingModalsReducer,
  candidateModalsReducer,
  generalModalsReducer
});
export default modalsGlobalReducer;
